export class DynamicRoles {
    public id:          string;
    public name:        string;
    public permissions: string[];
    public createdAt:   string;
    public modifiedAt:  string;
    public version:     number;
}